import { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import ProgressBar from '../ProgressBar/ProgressBar';
import SelectYesNo from '../SelectYesNo/SelectYesNo';
import MultiSelect from '../MultiSelect/MultiSelect';
import { getProducts } from '../../actions/product';
import styles from './Steps.module.css';

const Step9 = (props) => {
  const { 
    onSave, 
    stepsData, 
    getProducts,
    productsData,
  } = props;

  const [products, setProducts] = useState(stepsData.disliked_products || []);
  const [showProducts, setShowProducts] = useState();

  useEffect(() => {
    getProducts();

    let showProducts = null;
    if (stepsData.disliked_products !== undefined) {
      showProducts = !!stepsData.disliked_products?.length;
    }
    setShowProducts(showProducts);
  }, []);

  const onChangeHandler = (value) => {
    setShowProducts(value);
  };

  const onSaveHandler = () => {
    onSave({ 
      disliked_products: showProducts ? products : [],
    });
  };

  if (!productsData?.length) {
    return false;
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.productsContent}>
        <div className={styles.stepHeader}>
          Are there any types of food you don&apos;t like to eat?
        </div>
        <SelectYesNo 
          onChange={onChangeHandler}
          defaultValue={showProducts}
        />
        {showProducts && (
          <div className={styles.multiSelectWrapper}>
            <MultiSelect 
              options={productsData}
              onChange={setProducts}
              initialValue={products}
              placeholder="Enter food"
            />
          </div>
        )}
        <button
          className="green-button"
          onClick={onSaveHandler}
          disabled={showProducts === undefined}
        >
          Next
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.productsData,
});

const mapDispatchToProps = {
  getProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Step9);